import { Injectable } from '@angular/core';
import { Constants } from '../constants/constants';

@Injectable({
    providedIn: 'root'
})

export class StorageProvider {

    constructor() { }

    /**
     * Function for storing data against key locally
     * @param key string
     * @param data object
     */
    setSessionStorageData(key, data) {
        sessionStorage.setItem(key, JSON.stringify(data));
    }

    /**
     * * Function to fetch data against key locally
     * @param key string
     */
    getSessionStorageData(key) {
        return JSON.parse(sessionStorage.getItem(key));
    }

    /**
     * * Function to remove key locally
     * @param keyName string
     * @param storageType string
     */
    removeKeys(keyName) {
        sessionStorage.removeItem(keyName);
    }
}
